export default __webpack_public_path__ + "729dd8ad4d80be8d4e327e51d10d7bfb.png";